import axios from 'axios'
// introduce js-cookie for consistent usage hook with TPP
import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'

//req from exchange app, should hide some links on header and footer if
//derivatives access is false, this is specifically for UK users
async function getDerivativesAccess() {
  const isEligibleForDerivativeFeature = Cookies.get(
    'crypto.isEligibleForDerivativeFeature'
  )

  if (isEligibleForDerivativeFeature !== undefined) {
    return Boolean(isEligibleForDerivativeFeature)
  }

  const result = await axios.get('https://crypto.com/cdn-cgi/trace')
  const matches = result.data.match(/loc=([A-Z]+)/)

  //DEBUG should be GB & GBR
  if (matches && (matches[1] === 'GB' || matches[1] === 'GBR')) {
    return false
  }
  return true
}

export const useDerivativeAccess = () => {
  const [isDerivativeAccess, setDerivativeAccess] = useState(true)
  useEffect(() => {
    const checkDerivativesAccess = async () => {
      const isDerivativeAccess = await getDerivativesAccess()
      setDerivativeAccess(isDerivativeAccess)
    }
    checkDerivativesAccess()
  }, [])
  return isDerivativeAccess
}
